import React, { useMemo } from "react";

import { Grid } from "@mui/material";
import MainCard from "components/common/card/MainCard";
import UserListTableComponent from "components/tables/users/UsersListTable.component";
import Request from "../../../../core/requests";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import _ from "lodash";
import { useCallback } from "react";
import { Fragment } from "react";
import { TooltipAdd } from "components/common";
import { ListPagination } from "components/tables/list";
import AddUserContainer from "../add/AddUser.container";
import UpdateUserContainer from "../update/UpdateUser.container";
import { openSnackbar } from "store/slices/snackbar";
import { logout, refreshToken } from "store/user.store";
import ToolbarTableComponent from "components/tables/toolbar/ToolbarTable.component";
import { useTranslation } from "react-i18next";

const SUPERUSER = "superuser";

const UsersListContainer = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const {
        token,
        user,
        refresh_token,
        loading: loadingRefresh,
        error: errorRefresh,
    } = useSelector((state) => state.user);
    const TABLE_HEAD = useMemo(
        () => [
            { id: "email", label: "Email", alignRight: false, order: true },
            { id: "firstName", label: t("Name"), alignRight: false, order: true },
            { id: "lastName", label: t("Last name"), alignRight: false, order: true },
            { id: "enabled", label: t("Enabling"), alignRight: false, order: true },
            {
                id: "confirmed",
                label: t("Confirmation"),
                alignRight: false,
                order: true,
            },
            { id: "role", label: t("Role"), alignRight: false, order: true },
        ],
        [t]
    );
    const [values, setValues] = useState(null);
    const [page, setPage] = useState(0);
    const [slice, setSlice] = useState(25);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [success, setSuccess] = useState(null);
    const [dataFilter, setDataFilter] = useState([]);
    const [typeUser, setTypeUser] = useState(false);
    const [header, setHeader] = useState(TABLE_HEAD);
    const [open, setOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [userId, setUserId] = useState(null);
    const [isFirstRefresh, setIsFirstRefresh] = useState(true);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("email");
    const [dataSubmit, setDataSubmit] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [refresh, setRefresh] = useState(false);

    const onRequestSort = useCallback(
        (event, property) => {
            const isAsc = order === "asc" ? "desc" : "asc";
            setOrder(isAsc);
            setOrderBy(property);
        },
        [order]
    );

    const handleClickOpenDialog = useCallback(() => {
        setOpen(true);
    }, []);

    const handleCloseDialog = useCallback(() => {
        setOpen(false);
        setOpenEdit(false);
    }, []);

    const handleSearch = useCallback(
        (e) => {
            const searchValue = e.target.value;
            setSearchValue(e.target.value);
            const searchResult = data?.filter(
                (item) =>
                    item.firstName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    item.lastName?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    item.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
                    item.role?.toLowerCase().includes(searchValue.toLowerCase())
            );
            setDataFilter(searchResult);
        },
        [data]
    );

    const handleRowEditClick = useCallback(
        (item) => {
            if (user?.role === SUPERUSER) {
                setUserId(item);
                setOpenEdit(true);
            }
            // eslint-disable-next-line
        },
        [user]
    );

    const handleRowDeleteClick = useCallback(
        (id) => {
            if (user?.role === SUPERUSER) {
                setDataSubmit(id);
                Request.users
                    .deleteUserDetail({ id: id, token: token })
                    .then((resp) => onSuccess(resp))
                    .catch((error) => onError(error));
            }
        },
        // eslint-disable-next-line
        [user, token, isFirstRefresh]
    );

    const onSuccess = useCallback((resp) => {
        setSuccess(resp);
        setIsFirstRefresh(true);
        handleCloseDialog();
        dispatch(
            openSnackbar({
                open: true,
                message: Array.isArray(resp) ? resp[0].message : resp.message,
                variant: "alert",
                alert: {
                    color: Array.isArray(resp) ? resp[0].status : resp.status,
                },
                close: false,
            })
        );
        // eslint-disable-next-line
    }, []);

    const onError = useCallback(
        (error) => {
            setLoading(false);
            if (isFirstRefresh) {
                setLoading(false);
                if (error?.response?.status === 403) {
                    dispatch(logout());
                } else {
                    if (error?.response?.status !== 401) {
                        onFailure(error);
                    } else {
                        if (isFirstRefresh) {
                            dispatch(
                                refreshToken({
                                    grant_type: "refresh_token",
                                    refresh_token: user.refresh_token,
                                })
                            );
                            setIsFirstRefresh(false);
                        }
                    }
                }
            } else {
                onLogout(error);
            }
        },
        // eslint-disable-next-line
        []
    );

    const onFailure = useCallback((error) => {
        //se l'errore è 401 allora richiama refresh
        dispatch(
            openSnackbar({
                open: true,
                message: error.message ? error.message : "Errore",
                variant: "alert",
                alert: {
                    color: "error",
                },
                close: false,
            })
        );
        // eslint-disable-next-line
    }, []);

    const onPageChange = useCallback((event, newPage) => {
        setPage(newPage);
        // eslint-disable-next-line
    }, []);

    const onRowsPerPageChange = useCallback((event) => {
        setSlice(parseInt(event.target.value));
        setPage(0);
        // eslint-disable-next-line
    }, []);

    const onLogout = useCallback((error) => {
        if (error?.response?.status === 403 || error?.response?.status === 401) {
            dispatch(logout());
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setLoading(true);
        if (!loadingRefresh) {
            Request.users
                .all({
                    token: token,
                })
                .then((resp) => {
                    setValues(resp);
                    setLoading(false);
                    setIsFirstRefresh(true);
                })
                .catch((error) => onError(error));
        }
        // eslint-disable-next-line
    }, [token, success, refresh_token, refresh, loadingRefresh]);

    useEffect(() => {
        if (values && !_.isEmpty(values)) {
            setLoading(false);
            setData(values?.users);
            setDataFilter(values?.users);
            setCount(values?.users?.length);
        } else {
            setLoading(true);
            setData([]);
        }
    }, [values]);

    useEffect(() => {
        if (user && user.role === SUPERUSER) {
            setTypeUser(SUPERUSER);
            setHeader(
                _.concat(
                    TABLE_HEAD,
                    { id: "edit", label: "", alignRight: false },
                    { id: "delete", label: "", alignRight: false }
                )
            );
        }
    }, [user, TABLE_HEAD]);

    useEffect(() => {
        if (!isFirstRefresh && !errorRefresh && !loadingRefresh && dataSubmit) {
            handleRowDeleteClick(dataSubmit);
        }
        // eslint-disable-next-line
    }, [isFirstRefresh, loadingRefresh, errorRefresh, dataSubmit]);

    useEffect(() => {
        if (searchValue) {
            handleSearch({ target: { value: searchValue } });
        }
        // eslint-disable-next-line
    }, [searchValue, handleSearch, values]);

    const onRefresh = useCallback(() => {
        setRefresh(!refresh);
    }, [refresh]);

    return (
        <Fragment>
            <Grid container spacing={2} sx={{ width: "100%" }}>
                <Grid item xs={12}>
                    <ToolbarTableComponent
                        loading={loading}
                        handleSearch={handleSearch}
                        hasFilters={false}
                        hasClusters={false}
                        labelSearch={t("Search")}
                        valueSearch={searchValue}
                        onRefresh={onRefresh}
                    />
                </Grid>

                <Grid item xs={12} sx={{ width: "100%" }}>
                    <MainCard
                        title={t("User list")}
                        content={false}
                        secondary={
                            typeUser === SUPERUSER && (
                                <TooltipAdd
                                    title={t("Add user")}
                                    open={open}
                                    handleClickOpenDialog={handleClickOpenDialog}
                                >
                                    <AddUserContainer
                                        setSuccess={setSuccess}
                                        open={open}
                                        handleCloseDialog={handleCloseDialog}
                                    />
                                </TooltipAdd>
                            )
                        }
                    >
                        <UserListTableComponent
                            header={header}
                            data={dataFilter}
                            handleRowEditClick={handleRowEditClick}
                            handleRowDeleteClick={handleRowDeleteClick}
                            page={page}
                            rowsPerPage={slice}
                            typeUser={typeUser}
                            onRequestSort={onRequestSort}
                            order={order}
                            orderBy={orderBy}
                        />

                        <ListPagination
                            rowsPerPageOptions={[10, 25, 50, 100, 250]}
                            component="div"
                            count={count}
                            rowsPerPage={slice}
                            page={page}
                            onPageChange={onPageChange}
                            onRowsPerPageChange={onRowsPerPageChange}
                        />
                    </MainCard>
                    {openEdit && (
                        <UpdateUserContainer
                            open={openEdit}
                            userUp={userId}
                            handleCloseDialog={handleCloseDialog}
                            setSuccess={setSuccess}
                        />
                    )}
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default UsersListContainer;
